export default __webpack_public_path__ + "static/media/exchange.0d45522b.svg";